import { Outlet } from 'react-router-dom';
// import AppHeader from '../components/AppHeader';
import React from 'react';
import useFirebaseScreenTracking from '../utils/analytics/useFirebaseScreenTracking';
// import { SidebarNavigationMenu } from '../components/SidebarNavigationMenu';

const Root: React.FC = () => {
  // const [sideBarOpen, setSideBarOpen] =
  //   React.useState(false);

  // const handleToggleDrawer = () => {
  //   setSideBarOpen(!sideBarOpen);
  // };
  useFirebaseScreenTracking();

  return (
    <>
      {/* <AppHeader
        toggleDrawer={() => handleToggleDrawer()}
      /> */}
      {/* <div className="flex mt-16"> */}
      {/* <SidebarNavigationMenu
          open={sideBarOpen}
          setOpen={setSideBarOpen}
        /> */}
      {/* <div className="px-10 pt-6 w-full"> */}
      <Outlet />
      {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default Root;
